/* 子供区分 */
export default {
    // 小学生高学年
    UPPER_ELEMENTARY_SCHOOL: "10",
    // 小学生低学年
    LOWER_ELEMENTARY_SCHOOL: "15",
    // 幼児(寝具・食事あり)
    INFANT_BEDDING_MEAL: "20",
    // 幼児(食事のみ)
    INFANT_MEAL: "30",
    // 幼児(寝具のみ)
    INFANT_BEDDING: "40",
    // 幼児(寝具・食事なし)
    INFANT: "50"
}